module.exports = __webpack_public_path__ + "assets/img/title-1e776f35.png";